import {
  EntityAction,
  EntityActionHandlerType,
  EntityActionType
} from '../../entity-actions/interfaces/entity-actions';
import { JobAction } from '../interfaces/job-action';
import { JobsTrackers } from '../jobs-trackers';

export const JOB_ACTIONS_DISPLAY_DETAILS: EntityAction<JobAction>[] = [
  {
    action: JobAction.DOWNLOAD_SESSION_LOGS,
    type: EntityActionType.INLINE,
    actionHandlerType: EntityActionHandlerType.NAVIGATE,
    displayName: 'Download Session Log'
  },
  {
    action: JobAction.REFRESH,
    type: EntityActionType.INLINE,
    displayName: 'Refresh',
    actionHandlerType: EntityActionHandlerType.CUSTOM,
    inlineOptions: {
      size: 'md',
      icon: 'refresh',
      variation: 'outline'
    },
    trackingProps: {
      action: JobsTrackers.JOB_TRACKER_JOB_STATS_REFRESH_CLICK
    }
  },
  {
    action: JobAction.CANCEL,
    type: EntityActionType.INLINE,
    displayName: 'Cancel Job',
    actionHandlerType: EntityActionHandlerType.CONFIRM,
    inlineOptions: {
      variation: 'outline',
      size: 'md',
      icon: 'close'
    },
    trackingProps: {
      action: JobsTrackers.JOB_TRACKER_JOB_STATS_CANCEL_CLICK
    }
  }
];
